import { Controller, useFormContext } from 'react-hook-form';
import { TextAreaInput } from '~/components/ui/forms/text-area-input';
import { TextInput } from '~/components/ui/forms/text-input';
import { OutcropTagField } from '~/components/upload/supporting-object/outcrop-tag-field';
import { PictureTypeSelect } from '~/components/upload/supporting-object/picture-type-select-v4';
import type { PictureUpdateFormValues } from '~/utils/modules/supporting-object';

export function PictureFormFields({ studyId }: { studyId?: number }) {
  const form = useFormContext<PictureUpdateFormValues>();

  return (
    <div className="space-y-2">
      <TextInput {...form.register('name')} label="Name" required />
      <TextAreaInput
        {...form.register('description')}
        label="Description"
        required
      />
      <Controller
        control={form.control}
        name="type"
        render={({ field }) => (
          <PictureTypeSelect {...field} label="Type" required />
        )}
      />
      <TextInput {...form.register('author')} label="Author" />
      <TextInput {...form.register('scale')} label="Scale" />
      <TextInput {...form.register('comments')} label="Comments" />
      <TextInput
        type="number"
        {...form.register('priority')}
        label="Priority"
      />

      {studyId && (
        <OutcropTagField
          studyId={studyId}
          name="outcropTagId"
          label="Outcrop Tag"
        />
      )}
    </div>
  );
}
